import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Dossier\Partners\FetchDossierEnaosStatusController::__invoke
* @see app/Http/Controllers/Dossier/Partners/FetchDossierEnaosStatusController.php
* @route '/api/dossier/{dossier}/enaos/status'
*/
const FetchDossierEnaosStatusController = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: FetchDossierEnaosStatusController.url(args, options),
    method: 'get',
})

FetchDossierEnaosStatusController.definition = {
    methods: ["get","head"],
    url: '/api/dossier/{dossier}/enaos/status',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Dossier\Partners\FetchDossierEnaosStatusController::__invoke
* @see app/Http/Controllers/Dossier/Partners/FetchDossierEnaosStatusController.php
* @route '/api/dossier/{dossier}/enaos/status'
*/
FetchDossierEnaosStatusController.url = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { dossier: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { dossier: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            dossier: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        dossier: typeof args.dossier === 'object'
        ? args.dossier.id
        : args.dossier,
    }

    return FetchDossierEnaosStatusController.definition.url
            .replace('{dossier}', parsedArgs.dossier.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Dossier\Partners\FetchDossierEnaosStatusController::__invoke
* @see app/Http/Controllers/Dossier/Partners/FetchDossierEnaosStatusController.php
* @route '/api/dossier/{dossier}/enaos/status'
*/
FetchDossierEnaosStatusController.get = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: FetchDossierEnaosStatusController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Dossier\Partners\FetchDossierEnaosStatusController::__invoke
* @see app/Http/Controllers/Dossier/Partners/FetchDossierEnaosStatusController.php
* @route '/api/dossier/{dossier}/enaos/status'
*/
FetchDossierEnaosStatusController.head = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: FetchDossierEnaosStatusController.url(args, options),
    method: 'head',
})

export default FetchDossierEnaosStatusController